import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import Hero from './Page components/Contact/Contact';
import useSEO from '../../../../hooks/useSEO';

const CONTACT_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact Yamba Africa',
  url: 'https://yamba.africa/Contact-us',
  description:
    'Get in touch with the Yamba Africa team. We are here to help with your fundraiser, donation questions, or platform support.',
  publisher: {
    '@type': 'Organization',
    name: 'Yamba Africa',
    url: 'https://yamba.africa',
  },
};

const Contact = () => {
  useSEO({
    title: 'Contact Us – Get Support from Yamba Africa',
    description:
      'Have questions about your fundraiser or donation? Contact the Yamba Africa support team via email or our contact form. We are here to help.',
    url: 'https://yamba.africa/Contact-us',
    keywords:
      'contact Yamba Africa, fundraiser support Africa, Yamba helpdesk, crowdfunding help Africa',
    structuredData: CONTACT_STRUCTURED_DATA,
  });

  return (
    <div>
      <Header />
      <Hero />

      <Footer />
    </div>
  );
};

export default Contact;